export default [
  "modules/accordions",
  "modules/blog-checklist",
  "modules/pb-row-about-header",
  "modules/pb-row-certifications-promo",
  "modules/pb-row-contact",
  "modules/pb-row-features",
  "modules/pb-row-horizontal-scroller",
  "modules/pb-row-partners",
  "modules/pb-row-stats",
  "modules/pb-row-testimonials",
  "modules/post-single",
  "modules/rive-animation",
  "modules/sharing",
  "modules/text-ticker",
  "modules/video"
];
